<template>
  <div>
    <Toolbar
      :handle-edit="() => editHandler(item)"
      :handle-delete="del"
    >
      <template slot="left">
        <v-toolbar-title v-if="item">{{
          `${$options.servicePrefix} ${item["@id"]}`
        }}
        </v-toolbar-title>
      </template>
    </Toolbar>
    <br />
    <div v-if="item">
      <v-card
        max-width="1200px"
        class="mt-4 mx-auto"
      >
        <v-tabs
          v-model="tab"
          centered
          icons-and-text
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab>
            {{ $t("Profile") }}
            <v-icon>mdi-account</v-icon>
          </v-tab>
          <v-tab>
            {{ $t("Seminare") }}
            <v-icon>mdi-home-city</v-icon>
          </v-tab>
          <v-tab>
            {{ $t("Abonnements") }}
            <v-icon>mdi-wallet-membership</v-icon>
          </v-tab>
          <v-tab>
            {{ $t("Billing") }}
            <v-icon>mdi-cash</v-icon>
          </v-tab>
          <v-tab :disabled="!(item['@id'] && hasRole('ROLE_READ_NOTE'))">
            {{ $t('Notes') }}
            <v-icon>mdi-note</v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card
              flat
              class="mt-5"
            >
              <v-card-text class="text-center">
                <h3 class="mb-1">Knr.: {{ item.customerNumber }}</h3>
                <h1 class="font-weight-light mb-3 black--text">
                  {{ profile.salutation }} {{ profile.title }}
                  {{ profile.firstName }}
                  {{ profile.lastName }}
                </h1>
                <h2
                  class="mb-1 grey--text"
                  v-if="profile.company"
                >
                  {{ profile.company }}
                </h2>
                <h4 class="mb-1 grey--text">E-Mail: {{ item.email }}</h4>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                  >
                    <h3>Aktiv</h3>
                    <v-icon v-if="item.enabled">mdi-check-circle</v-icon>
                    <v-icon v-else>mdi-close-circle</v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                  >
                    <h3>Erstellt</h3>
                    am <strong>{{ formatDateTime(item.createdAt, "L") }}</strong><br />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                  >
                    <h3>Aktualisiert</h3>
                    am <strong>{{ formatDateTime(item.updatedAt, "L") }}</strong><br />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                  >
                    <h3>Gesperrt</h3>
                    <v-icon v-if="item.locked">mdi-check-circle</v-icon>
                    <v-icon v-else>mdi-close-circle</v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                  >
                    <h3>Firmenaccount</h3>
                    <v-icon v-if="item.isBusiness">mdi-check-circle</v-icon>
                    <v-icon v-else>mdi-close-circle</v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    v-if="item.vatId"
                  >
                    <h3>{{ $t('vatId') }}</h3>
                    {{ item.vatId }}
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              class="mt-5"
              flat
            >
              <v-card-text>
                <template v-if="addressesLoaded">
                  <AddressList :addressObjects="this.addressObjects" />
                </template>
                <template v-else>
                  <p>Keine Daten verfügbar</p>
                </template>
                <v-btn
                  color="primary"
                  dark
                  @click="addressDialogControl()"
                >
                  {{ $t("AddAddress") }}
                </v-btn>
                <AddressDialog
                  v-model="showAddressDialogForm"
                  :address-item="{ country: 'DE' }"
                  :handle-created="onAddressCreated"
                  :handle-deleted="onAddressDeleted"
                  :show-handle="showAddressDialogForm"
                  :title="$t('AddAddress')"
                  @close="addressDialogControl(true)"
                />
              </v-card-text>
            </v-card>
            <v-card
              class="mt-5"
              flat
            >
              <v-card-text>
                <ContactList
                  :contact-objects="contactsObjects"
                  :contacts-server-length="profile.contacts.length"
                  :handle-created="onContactCreated"
                  :handle-deleted="onContactDeleted"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
              flat
              class="mt-5"
            >
              <v-card-title>{{ $t("Seminars") }}</v-card-title>
              <v-card-text>
                <template v-if="participants.length">
                  <v-data-table
                    :headers="seminarHeaders"
                    :items="participants"
                    class="elevation-1"
                    item-key="@id"
                  >
                    <template
                      slot="item.seminarInfos.firstSeminarModuleStartDate"
                      slot-scope="{ item }"
                    >
                      <template v-if="item.seminarInfos">
                        {{ formatDateTime(item.seminarInfos.firstSeminarModuleStartDate) }}
                      </template>
                    </template>
                    <template
                      slot="item.deletedAt"
                      slot-scope="{ item }"
                    >
                      <span
                        v-if="item.deletedAt"
                        style="color:red"
                      >{{ $t('cancelled') }}</span>
                      <span
                        v-else
                        style="color:green"
                      >{{ $t('signedup') }}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="showSeminar(item)" class="mr-2" small>
                            mdi-eye
                          </v-icon>
                        </template>
                        <span>{{ $t('SeminarShow') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="!item.deletedAt">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="confirmSendInvoice(item)" class="mr-2" small>
                            mdi-cash
                          </v-icon>
                        </template>
                        <span>
                          <template v-if="item.firstInvoice">{{ $t('ReSendInvoice') }}</template>
                          <template v-else>{{ $t('SendInvoice') }}</template>
                        </span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="item.participated && !item.deletedAt">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="confirmSendConfirmation(item)" class="mr-2" small>
                            mdi-email-check-outline
                          </v-icon>
                        </template>
                        <span>{{ $t('SendParticipantConfirmation') }}</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </template>
                <template v-else>
                  <p>Keine Daten verfügbar</p>
                </template>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
              flat
              class="mt-5"
            >
              <v-card-title>{{ $t("Abonnements") }}</v-card-title>
              <v-card-text>
                <template v-if="subscribers.length">
                  <v-data-table
                    :headers="subscriberHeaders"
                    :items="subscribers"
                    class="elevation-1"
                    item-key="@id"
                  >
                    <template
                      slot="item.subscription.start"
                      slot-scope="{ item }"
                    >
                      <template v-if="item.subscription">
                        {{ formatDateTime(item.subscription.start) }} - {{ formatDateTime(item.subscription.end) }}
                      </template>
                    </template>
                    <template
                      slot="item.createdAt"
                      slot-scope="{ item }"
                    >
                      {{ formatDateTime(item.createdAt) }}
                    </template>
                    <template
                      slot="item.deletedAt"
                      slot-scope="{ item }"
                    >
                      <span
                        v-if="item.deletedAt"
                        style="color:red"
                      >{{ $t('cancelled') }}</span>
                      <span
                        v-else
                        style="color:green"
                      >{{ $t('signedup') }}</span>
                    </template>
                    <ActionCell
                      :handle-show="() => showSubscription(props.item)"
                      slot="item.action"
                      slot-scope="props"
                    >
                    </ActionCell>
                  </v-data-table>
                </template>
                <template v-else>
                  <p>Keine Daten verfügbar</p>
                </template>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
              flat
              class="mt-5"
            >
              <v-card-title>{{ $t("Invoices") }}</v-card-title>
              <v-card-text>
                <template v-if="invoicesLoaded">
                  <v-data-table
                    :headers="invoiceHeaders"
                    :items="invoiceObjects"
                    class="elevation-1"
                    item-key="@id"
                  >
                    <template
                      slot="item.customer"
                      slot-scope="{ item }"
                    >
                      {{ getCustomerItem(item["customer"], "customerNumber") }}
                    </template>
                    <template
                      slot="item.date"
                      slot-scope="{ item }"
                    >
                      {{ formatDateTime(item["date"], "L") }}
                    </template>
                    <template v-slot:item.action="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="showInvoice(item)" class="mr-2" small>
                            mdi-eye
                          </v-icon>
                        </template>
                        <span>{{ $t('InvoiceShow') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="item.participant">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" @click="confirmResendInvoiceFromInvoiceTab(item)" class="mr-2" small>
                            mdi-cash
                          </v-icon>
                        </template>
                        <span>{{ $t('ReSendInvoice') }}</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </template>
                <template v-else>
                  <p>Keine Daten verfügbar</p>
                </template>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="item['@id'] && hasRole('ROLE_READ_NOTE')">
            <v-card
              flat
              class="mt-5"
            >
              <NoteListAndAddGql
                :default-item-props="{ customer: item['@id'] }"
                object-type="customer"
                :show-message="showMessage"
                :title="$t('NotesPrivate')"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import { mapFields } from "vuex-map-fields";
  import ActionCell from "@/components/ActionCell";
  import AddressDialog from "@/components/address/AddressDialog";
  import AddressList from "@/components/address/AddressList";
  import AddressMixin from "@/mixins/AddressMixin";
  import ContactList from "@/components/contact/ContactList";
  import ContactMixin from "@/mixins/ContactMixin";
  import CustomerMixin from "@/mixins/CustomerMixin";
  import InvoiceMixin from "@/mixins/InvoiceMixin";
  import Loading from "../../components/Loading";
  import NotificationMixin from "@/mixins/NotificationMixin";
  import ParticipantMixin from "@/mixins/ParticipantMixin";
  import SubscriberMixin from "@/mixins/SubscriberMixin";
  import ProfileMixin from "@/mixins/ProfileMixin";
  import SeminarMixin from "@/mixins/SeminarMixin";
  import SeminarModuleMixin from "@/mixins/SeminarModuleMixin";
  import ShowMixin from "../../mixins/ShowMixin";
  import Toolbar from "../../components/Toolbar";
  import NoteListAndAddGql from '../../components/note/ListAndAddGql';

  const servicePrefix = "Customer";

  export default {
    name: "CustomerShow",
    servicePrefix,
    components: {
      ActionCell,
      AddressDialog,
      AddressList,
      ContactList,
      Loading,
      Toolbar,
      NoteListAndAddGql
    },
    mixins: [
      AddressMixin,
      ContactMixin,
      CustomerMixin,
      InvoiceMixin,
      NotificationMixin,
      ParticipantMixin,
      SubscriberMixin,
      ProfileMixin,
      SeminarMixin,
      SeminarModuleMixin,
      ShowMixin,
    ],
    data() {
      return {
        participants: [],
        subscribers: [],
        tab: true,
        isLoadingProfile: false,
        isLoadingAddresses: false,
        showAddressDialogForm: [],
        invoiceHeaders: [
          {
            text: this.$i18n.t("type"),
            value: "type",
            sortable: false,
            align: "left",
          },
          {
            text: this.$t("invoiceNumber"),
            value: "number",
          },
          { text: this.$i18n.t("customerNumber"), value: "customer" },
          { text: this.$i18n.t("invoiceDate"), value: "date" },
          {
            text: this.$i18n.t("Actions"),
            value: "action",
            sortable: false,
            align: "center",
          },
        ],
        subscriberHeaders: [
          { text: this.$i18n.t("name"), value: "subscription.name" },
          { text: this.$i18n.t("Number"), value: "subscription.number" },
          { text: this.$i18n.t("Status"), value: "deletedAt" },
          {
            text: this.$i18n.t("SubscriberSubscribedAt"),
            value: "createdAt",
          },
          {
            text: this.$i18n.t("SubscriptionPeriod"),
            value: "subscription.start",
          },
          {
            text: this.$i18n.t("Actions"),
            value: "action",
            sortable: false,
            align: "center",
          },
        ],
      };
    },
    computed: {
      ...mapFields("customer", {
        isLoading: "isLoading",
      }),
      ...mapGetters("customer", ["find"]),
      seminarHeaders() {
        const headers = [
          { text: this.$i18n.t("name"), value: "seminarInfos.name" },
          { text: this.$i18n.t("Number"), value: "seminarInfos.number" },
          { text: this.$i18n.t("Status"), value: "deletedAt" },
          { text: this.$i18n.t("firstSeminarModuleStartDate"), value: "seminarInfos.firstSeminarModuleStartDate" },
          { text: this.$i18n.t("Actions"), value: "action", sortable: false, align: "center" },
        ];
        if (this.item?.isBusiness) {
          headers.splice(2, 0, { text: this.$i18n.t("Participant"), value: "participantName", sortable: false });
        }
        return headers;
      },
      addressesLoaded() {
        if (Array.isArray(this.profile.addresses) === false) {
          return true;
        }
        return this.profile.addresses.length === this.addressObjects.length;
      },
      invoicesLoaded() {
        if (Array.isArray(this.invoices) === false) {
          return true;
        }
        return this.item.invoices.length === this.invoiceObjects.length;
      },
      participantsLoaded() {
        if (Array.isArray(this.participants) === false) {
          return true;
        }
        return this.item.participants.length === this.participantObjects.length;
      },
      subscribersLoaded() {
        if (Array.isArray(this.subscribers) === false) {
          return true;
        }
        return this.item.subscribers.length === this.subscriberObjects.length;
      },
      addressObjects() {
        if (Array.isArray(this.profile.addresses) === false) {
          return [];
        }
        return this.profile.addresses.map((addressId) =>
          this.resolveAddress(addressId)
        ).filter((address) => address);
      },
      contactsObjects() {
        if (Array.isArray(this.profile.contacts) === false) {
          return [];
        }
        return this.profile.contacts.map((contactId) =>
          this.resolveContact(contactId)
        ).filter((contact) => contact);
      },
      invoiceObjects() {
        if (Array.isArray(this.item.invoices) === false) {
          return [];
        }
        return this.item.invoices.map((invoiceId) =>
          this.resolveInvoice(invoiceId)
        ).filter((invoice) => invoice);
      },
      participantObjects() {
        if (Array.isArray(this.item.participants) === false) {
          return [];
        }
        return this.item.participants.map((participantId) => {
          return this.resolveParticipant(participantId)
        }).filter((participant) => participant);
      },
      subscriberObjects() {
        if (Array.isArray(this.item.subscribers) === false) {
          return [];
        }
        return this.item.subscribers.map((subscriberId) => {
          return this.resolveSubscriber(subscriberId)
        }).filter((subscriber) => subscriber);
      },
      profile() {
        if (
          this.profileCreate &&
          typeof this.item.profile === "object" &&
          this.item.profile !== null
        ) {
          // create object, keep it simple
          return this.item.profile;
        }
        if (typeof this.item.profile !== "undefined") {
          return this.resolveProfile(this.item.profile);
        }
        return null;
      },
    },
    methods: {
      ...mapActions("customer", {
        deleteItem: "del",
        reset: "reset",
        retrieve: "load",
      }),
      ...mapActions('participant', {
        getParticipants: 'fetchAll',
        participantAction: 'action',
      }),
      ...mapActions('subscriber', {
        getSubscribers: 'fetchAll',
      }),
      async loadAllParticipants() {
        this.participants = await this.getParticipants({
          'show_all_participants': 1,
          'customer': this.item['@id']
        })
      },
      async loadAllSubscribers() {
        this.subscribers = await this.getSubscribers({
          'show_all_subscribers': 1,
          'customer': this.item['@id']
        })
      },
      onAddressCreated(createdAddress) {
        this.profile.addresses.push(createdAddress["@id"]);

        if (this.profile["@id"]) {
          let fakeItem = {
            "@id": this.profile["@id"],
            addresses: this.profile.addresses,
          };
          this.updateProfile(fakeItem);
        } else {
          // this case should not occur! But this is to cover this case if it ever happens that there is no profile
          this.createProfile({
            addresses: this.profile.addresses,
            customer: this.item["@id"],
          });
          this.$router.go();
        }
      },
      onContactCreated(createdContact) {
        this.profile.contacts.push(createdContact["@id"]);

        if (this.profile["@id"]) {
          let fakeItem = {
            "@id": this.profile["@id"],
            contacts: this.profile.contacts,
          };
          this.updateProfile(fakeItem);
        } else {
          // this case should not occur! But this is to cover this case if it ever happens that there is no profile
          this.createProfile({
            contacts: this.profile.contacts,
            customer: this.item["@id"],
          });
          this.$router.go();
        }
      },
      onAddressDeleted(deletedAddress) {
        // TODO: Call early, prevent not found
        this.removeProfileRelated(
          this.profile,
          "addresses",
          deletedAddress["@id"]
        );
      },
      addressDialogControl(close = false) {
        if (!close) {
          this.showAddressDialogForm.push("new");
        } else {
          this.showAddressDialogForm.splice(
            this.showAddressDialogForm.indexOf("new"),
            1
          );
        }
      },
      confirmSendInvoice(item) {
        const message = item.firstInvoice
          ? this.$t('confirmReSendParticipantInvoiceMessage')
          : this.$t('confirmSendParticipantInvoiceMessage');
        this.$confirm(message, {
          buttonTrueText: this.$t('Yes'),
          buttonFalseText: this.$t('No')
        }).then((response) => {
          if (!response) return;
          this.participantAction({ item, action: 'generateAndSendParticipantInvoice' });
        });
      },
      confirmResendInvoiceFromInvoiceTab(invoiceItem) {
        this.confirmSendInvoice({ '@id': invoiceItem.participant, firstInvoice: invoiceItem['@id'] });
      },
      confirmSendConfirmation(item) {
        this.$confirm(this.$t('confirmSendParticipantConfirmationMessage'), {
          buttonTrueText: this.$t('Yes'),
          buttonFalseText: this.$t('No')
        }).then((response) => {
          if (!response) return;
          this.participantAction({ item, action: 'sendParticipantConfirmation' });
        });
      },
      showInvoice(invoiceItem) {
        this.$router.push({
          name: "InvoiceUpdate",
          params: { id: invoiceItem["@id"] },
        });
      },
      showSeminar(participantItem) {
        this.$router.push({
          name: "SeminarShow",
          params: { id: `/seminars/${participantItem?.seminarInfos.id}` },
        });
      },
      showSubscription(subscriberItem) {
        this.$router.push({
          name: "SubscriptionUpdate",
          params: { id: `/subscriptions/${subscriberItem?.subscription.id}` },
        });
      },
      onContactDeleted(contact) {
        this.removeProfileRelated(this.profile, "contacts", contact["@id"]);
      },
    },
    watch: {
      participantHandled() {
        if (this.participantHandled === null) return;
        if (this.participantActionHandled === 'generateAndSendParticipantInvoice') {
          this.showMessage(this.$t('ParticipantInvoiceSent'));
          this.participantActionHandled = null;
          this.participantHandled = null;
        }
        if (this.participantActionHandled === 'sendParticipantConfirmation') {
          this.showMessage(this.$t('ParticipantConfirmationSent'));
          this.participantActionHandled = null;
          this.participantHandled = null;
        }
      }
    },
    async created() {
      this.loadAllParticipants()
      this.loadAllSubscribers()
    }
  };
</script>
